import React from 'react';
import { MDBSelect, MDBRow, MDBCol, MDBInput, MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBIcon, MDBCardBody } from 'mdbreact';
import Header from '../Components/ComponentFragments/Header';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Colors from '../Styles/Colors';
import _ from 'lodash';

export default class EarningsCalculator extends React.Component {

    constructor(props) {
        super();
        this.dataLayer = new DataLayer();
        this.formatter = new Formatter();
        this.state = {
            transactionData: [],
            yearData: [],
            segmentData: [],
            selectedYear: 0,
            selectedSegment: 0,
            totalEarnings: {
                earnings: 0,
                calculatedEarnings: 0
            },
            tmaUser: JSON.parse(localStorage.getItem("TMAUser"))
        }

        this.loadCurrentEarnings = this.loadCurrentEarnings.bind(this);
        this.handleYearSelectChange = this.handleYearSelectChange.bind(this);
        this.handleSegmentSelectChange = this.handleSegmentSelectChange.bind(this);
        this.loadActuals = this.loadActuals.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    async loadActuals() {
        this.props.loaderOn()
        let url = '';
        switch (this.state.tmaUser.data.statusCode1) {
            case 'T':
                url = '/teamleader/getteamearnings?periodId=' + this.state.selectedSegment
                break;

            case 'M':
                url = '/manager/getunitearnings?periodId=' + this.state.selectedSegment
                break;

            default:
                break;
        }
        let transactionData = await this.dataLayer.Get(url);
        let totalEarnings = transactionData.filter((entry) => entry.code === '-');
        transactionData.splice(transactionData.lastIndexOf(totalEarnings), 1);

        this.setState({
            transactionData: transactionData,
            totalEarnings: totalEarnings[0]
        })
        this.props.loaderOff();
    }

    async loadSegmentsForYear(year) {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getsegmentsforyear?yearId=' + year, 200);
        let segData = [];
        result.data.forEach((segment) => segData.push({ checked: false, value: segment.periodId, text: segment.description }));

        segData[0].checked = true;
        this.setState({
            segmentData: segData,
            //toWeekData: toWeeksData,
            selectedSegment: segData[0].value,
            //selectedToWeek: toWeeksData[0].value
        })

        this.props.loaderOff();
    }

    handleYearSelectChange(selected) {
        this.setState({
            selectedYear: selected[0]
        });
        this.loadSegmentsForYear(selected[0])
    }

    handleSegmentSelectChange(selected) {
        this.setState({
            selectedSegment: selected[0]
        });
    }

    async componentWillMount() {
        let result = await this.dataLayer.Get('/common/getyears', 200);
        let yearsData = [];
        result.data[0].forEach((year) => yearsData.push({ checked: false, value: year.value, text: year.label }));
        yearsData[0].checked = true;

        this.setState({
            yearData: yearsData,
            selectedYear: yearsData[0].value
        })

        //this.loadCurrentEarnings();
    }

    async loadCurrentEarnings() {
        let url = '';
        switch (this.state.tmaUser.data.statusCode1) {
            case 'T':
                url = '/teamleader/getteamearnings'
                break;

            case 'M':
                url = '/manager/getunitearnings'
                break;

            default:
                break;
        }
        let transactionData = await this.dataLayer.Get(url);
        let totalEarnings = transactionData.filter((entry) => entry.code === '-');
        transactionData.splice(transactionData.lastIndexOf(totalEarnings), 1);

        this.setState({
            transactionData: transactionData,
            totalEarnings: totalEarnings[0]
        })
        this.props.loaderOff();
    }

    async calculateEarnings(form) {
        let url = '';
        let calculationValues = {};

        switch (this.state.tmaUser.data.statusCode1) {
            case 'T':
                url = '/teamleader/getcalculatedearnings'
                calculationValues = {
                    UnitSales: form.unitSales.value,
                    PromoteoutSales: form.promoteoutSales.value,
                    QualifiedTeamRecruits: form.teamQualifiedRecruits.value,
                    TeamSales: form.teamSales.value,
                    TLPromoteoutTwoHalfPerc: form.promoteoutTwoHalfPercent.value,
                    TLPromoteOutOnePerc: form.promoteoutOnePercent.value,
                    TLPromoteoutFourHalfPerc: form.promoteoutFourHalfPercent.value,
                    TLPromoteOutTwoPerc: form.promoteoutTwoPercent.value,
                    QualifiedPromoteouts: form.qualifiedPromoteouts.value
                };
                break;

            case 'M':
                url = '/manager/getcalculatedearnings'
                calculationValues = {
                    UnitSales: form.unitSales.value,
                    PromoteoutSales: form.promoteoutSales.value
                };
                break;

            default:
                break;
        }

        let calculatedResult = await this.dataLayer.Post(url, calculationValues);
        let tempTotalData = this.state.totalEarnings;
        tempTotalData.calculatedEarnings = calculatedResult.filter((transaction) => transaction.code === '-')[0].calculatedEarnings;
        let tempTransactionData = [];
        this.state.transactionData.forEach(transaction => {
            var obj = _.find(calculatedResult, function (o) { return o.code == transaction.code; });
            transaction.calculatedEarnings = obj.calculatedEarnings;
            transaction.figureSupplied = obj.figureSupplied;
            tempTransactionData.push(transaction);
        });

        this.setState({
            transactionData: tempTransactionData,
            totalEarnings: tempTotalData
        });
    }

    async onSubmit(event) {
        event.preventDefault();
        this.props.loaderOn();
        await this.calculateEarnings(event.target);
        this.props.loaderOff();
    }

    render() {
        return (
            <form onSubmit={this.onSubmit}>
            <div>
                <Header headerText="Earnings Calculator"
                    hideSearch={true}
                    subHeaderText="(Click Load Actual to load actual earnings for selected segment)"
                />

                <MDBRow className="mt-5">
                    <MDBCol md="6" sm="12" className="mb-3">
                        <MDBCard className="cascading-admin-card">
                            <div className="admin-up">
                                <MDBIcon icon="coins" style={{ backgroundColor: Colors.green }} />
                                <div className="data">
                                    <h5><strong>Total Earnings</strong></h5>
                                </div>
                            </div>
                            <MDBCardBody>
                                <MDBRow>
                                    <MDBCol sm="6" xs="6" className="mb-r text-center">
                                        <p>Actual <br />
                                            <strong>{this.formatter.formatCurrency(this.state.totalEarnings.earnings)}</strong>
                                        </p>

                                    </MDBCol>
                                    <MDBCol sm="6" xs="6" className="mb-r text-center">
                                        <p>Calculated <br />
                                            <strong>{this.formatter.formatCurrency(this.state.totalEarnings.calculatedEarnings)}</strong>
                                        </p>
                                    </MDBCol>
                                </MDBRow>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    
                </MDBRow>
                    <MDBRow>
                        <MDBCol md="12" sm="12" className="mb-3">
                        <MDBCard style={{marginBottom:"25px"}} className="card-body">

                            <MDBRow>
                                <MDBCol md="6" sm="12">
                                    <MDBSelect label="Year..."
                                        options={this.state.yearData}
                                        selected="Filter"
                                        getValue={this.handleYearSelectChange}
                                        required
                                    />
                                </MDBCol>
                                <MDBCol md="6" sm="12">
                                    <MDBSelect label="Segment..."
                                        options={this.state.segmentData}
                                        selected="Filter"
                                        getValue={this.handleSegmentSelectChange}
                                        required

                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol>
                                    <MDBBtn className="float-right" onClick={this.loadActuals}>Load Actual</MDBBtn>
                                </MDBCol>
                            </MDBRow>
                        
                            {
                                this.state.tmaUser.data.statusCode1 == 'T' ?
                                    (
                                        <div>
                                        {/*Team Leader Display*/}
                                       
                                        
                                            <MDBRow>
                                                <MDBCol md="6" sm="12">
                                                    <MDBInput
                                                        label="Unit Sales"
                                                        name="unitSales"
                                                        type="number"
                                                        required
                                                    />
                                                </MDBCol>
                                                <MDBCol md="6" sm="12">
                                                    <MDBInput
                                                        label="Promoteout Sales"
                                                        name="promoteoutSales"
                                                        type="number"
                                                        required
                                                    />
                                                </MDBCol>
                                                <MDBCol md="6" sm="12">
                                                    <MDBInput
                                                        label="Team Qualified Recruits"
                                                        name="teamQualifiedRecruits"
                                                        type="number"
                                                        required
                                                    />
                                                </MDBCol>
                                                <MDBCol md="6" sm="12">
                                                    <MDBInput
                                                        label="Team Sales"
                                                        name="teamSales"
                                                        type="number"
                                                        required
                                                    />
                                                </MDBCol>
                                                <MDBCol md="6" sm="12">
                                                    <MDBInput
                                                        label="TL Promoteout 2.5%"
                                                        name="promoteoutTwoHalfPercent"
                                                        type="number"
                                                        required
                                                    />
                                                </MDBCol>
                                                <MDBCol md="6" sm="12">
                                                    <MDBInput
                                                        label="TL Promoteout 1%"
                                                        name="promoteoutOnePercent"
                                                        type="number"
                                                        required
                                                    />
                                                </MDBCol>
                                                <MDBCol md="6" sm="12">
                                                    <MDBInput
                                                        label="TL Promoteout 4.5% (New)"
                                                        name="promoteoutFourHalfPercent"
                                                        type="number"
                                                        required
                                                    />
                                                </MDBCol>
                                                <MDBCol md="6" sm="12">
                                                    <MDBInput
                                                        label="TL Promoteout 2% (New)"
                                                        name="promoteoutTwoPercent"
                                                        type="number"
                                                        required
                                                    />
                                                </MDBCol>
                                                <MDBCol md="6" sm="12">
                                                    <MDBInput
                                                        label="Qualified Promoteouts"
                                                        name="qualifiedPromoteouts"
                                                        type="number"
                                                        required
                                                    />
                                                </MDBCol>
                                            </MDBRow>
                                            
                                        </div>
                                    ) : (
                                        <div>
                                            {/*Manager Display*/}
                                            <MDBRow>
                                                <MDBCol md="6" sm="12">
                                                    <MDBInput
                                                        label="Unit Sales"
                                                        name="unitSales"
                                                        type="number"
                                                        required
                                                    />
                                                </MDBCol>
                                                <MDBCol md="6" sm="12">
                                                    <MDBInput
                                                        label="Promoteout Sales"
                                                        name="promoteoutSales"
                                                        type="number"
                                                        required
                                                    />
                                                </MDBCol>
                                            </MDBRow>
                                        </div>
                                    )
                            }
                            <MDBCol md="12" sm="12">
                                <MDBBtn type="submit" className="float-right">Calculate</MDBBtn>
                            </MDBCol>
                        
                            </MDBCard>
                            </MDBCol>
                </MDBRow>
                <MDBRow>
                    {
                        this.state.transactionData.map((resultEntry) => {
                            return (
                                <MDBCol md="4" sm="12">
                                    <MDBCard className="card-body mb-4">
                                        <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>{resultEntry.code} - {resultEntry.description}</MDBCardTitle>
                                        <hr />
                                        <MDBCardText>
                                            <MDBRow>
                                                <MDBCol sm="6" className="text-center">
                                                    <p><strong><u>Actual</u></strong></p>
                                                    <p style={{ fontSize: "14px" }}>Figure Used<br /> <strong>{this.formatter.formatCurrency(resultEntry.figureUsed)}</strong></p>
                                                    <p style={{ fontSize: "14px" }}>Trans Amount<br /> <strong>{this.formatter.formatCurrency(resultEntry.earnings)}</strong></p>
                                                </MDBCol>
                                                <MDBCol sm="6" className="text-center">
                                                    <p><strong><u>Calculated</u></strong></p>
                                                    <p style={{ fontSize: "14px" }}>Figure Used<br /> <strong>{this.formatter.formatCurrency(resultEntry.figureSupplied)}</strong></p>
                                                    <p style={{ fontSize: "14px" }}>Trans Amount<br /> <strong>{this.formatter.formatCurrency(resultEntry.calculatedEarnings)}</strong></p>
                                                </MDBCol>
                                            </MDBRow>
                                        </MDBCardText>
                                    </MDBCard>
                                </MDBCol>
                            );
                        })
                    }
                </MDBRow>
                </div>
            </form>
        );
    }
}